import { useRouter } from '@application/utils';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { Container } from '..';
import { images } from './assets/images';
import * as Styled from './styled';

export const PressSection: FC = () => {
  const { translate } = useTranslation();
  const { country } = useRouter();

  // We would show this section only for Belgium now
  if (country !== 'be') {
    return null;
  }

  return (
    <Container>
      <Styled.PaddingWrapper>
        <Styled.Wrapper>
          <Styled.BlueCard>
            <Styled.PurpleCardTitle
              dangerouslySetInnerHTML={{ __html: translate('common.sections.press') }}
            />
          </Styled.BlueCard>
          <Styled.WhiteCard>
            <Styled.WhiteCardTitle
              dangerouslySetInnerHTML={{ __html: translate('common.sections.press') }}
            />
            <Styled.ItemContainer>
              {images.map((image, index) => (
                <Styled.ItemWrapper key={index}>
                  <Styled.ItemImage src={image} />
                </Styled.ItemWrapper>
              ))}
            </Styled.ItemContainer>
          </Styled.WhiteCard>
        </Styled.Wrapper>
      </Styled.PaddingWrapper>
    </Container>
  );
};
